'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var TwoManHandlingCTA = styled__default['default'].button.withConfig({ displayName: "ww-uikit_TwoManHandlingCTA_ls4hrdbs", componentId: "sc-1okvefy" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    text-align: left;\n    text-decoration: underline;\n    cursor: pointer;\n    padding-top: 3px;\n"], ["\n    color: ", ";\n    text-align: left;\n    text-decoration: underline;\n    cursor: pointer;\n    padding-top: 3px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
});
var templateObject_1;

exports.default = TwoManHandlingCTA;
//# sourceMappingURL=index.js.map
